// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3ZOOo","notes":"Notes_notes__2F54z","note":"Notes_note__luWGg","markdown":"Notes_markdown__2EhPD"};